import React, { useState } from 'react';
import axios from 'axios';

const ManageWithdraw = () => {
  const [email, setEmail] = useState('');
  const [userData, setUserData] = useState(null);
  const [selectedField, setSelectedField] = useState('');
  const [newValue, setNewValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  // Fetch user details by email when the component mounts or email changes
  const fetchUserData = async () => {
    if (!email) {
      setError('Please enter an email to fetch user data.');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get('https://sharedvision-partners.online/v1/API/admgetuser.php', {
        params: { email }
      });

      console.log('Response from backend:', response.data); // Log the response to debug

      if (response.data && response.data.status === 'success' && response.data.data) {
        setUserData(response.data.data); // Assuming the response contains user data under `data`
        setError('');
      } else {
        setError('No user data found for this email.');
        setUserData(null);
      }
    } catch (err) {
      console.error('Error fetching user data:', err); // Log the error to the console
      setError('Error fetching user data.');
      setUserData(null);
    } finally {
      setLoading(false);
    }
  };

  // Handle form submission to update user data
  const handleUpdateUser = async () => {
    if (!selectedField || !newValue) {
      alert('Please select a field and enter a new value.');
      return;
    }

    setLoading(true);
    try {
      await axios.post('https://sharedvision-partners.online/v1/API/admgetuser.php', {
        email,
        field: selectedField,
        newValue
      });
      setSuccessMessage('User info updated successfully.');
      setLoading(false);
    } catch (error) {
      console.error('Error updating user data:', error); // Log the error to the console
      setLoading(false);
      alert('Error updating user data.');
    }
  };

  // Validate email format
  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailPattern.test(email);
  };

  const handleEmailSubmit = () => {
    if (email && validateEmail(email)) {
      setError('');
      setUserData(null); // Clear existing user data before fetching new data
      setSelectedField('');  // Clear the selected field
      setNewValue('');  // Clear the new value
      fetchUserData(); // Fetch user data on button click
    } else {
      setError('Please enter a valid email.');
    }
  };

  // Handle logout confirmation modal
  const handleLogout = () => {
    setShowLogoutModal(true); // Show logout confirmation modal
  };

  // Confirm the logout action
  const confirmLogout = () => {
    // Logic to clear session or localStorage (if needed)
    // sessionStorage.clear();  // example if using sessionStorage
    // localStorage.clear();    // example if using localStorage

    setShowLogoutModal(false);
    alert('Logged out successfully.');
    // Optionally, redirect to login page or homepage
    window.location.href = '/';  // Change to your desired URL
  };

  // Cancel logout action
  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  return (
    <div className="form-container">
      <h2>Update User Information</h2>

      <div className="input-group">
        <label htmlFor="email">Enter User Email:</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter user email"
        />
       
        <button onClick={handleEmailSubmit} disabled={!validateEmail(email)}>Fetch User Details</button>

      </div>

      {error && <div className="error">{error}</div>}

      {userData && (
        <div className="user-details">
          <h3>User Details</h3>
          <table>
            <thead>
              <tr>
                <th>Field</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(userData).map((key) => (
                <tr key={key}>
                  <td>{key}</td>
                  <td>{userData[key]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {successMessage && <div className="success-message">{successMessage}</div>}

      <div className="update-options">
        <label htmlFor="update-field">Select Field to Update:</label>
        <select
          id="update-field"
          value={selectedField}
          onChange={(e) => setSelectedField(e.target.value)}
        >
          <option value="">Select a field</option>
          {userData && Object.keys(userData).map((key) => (
            <option key={key} value={key}>
              {key}
            </option>
          ))}
        </select>

        <label htmlFor="new-value">Enter New Value:</label>
        <input
          type="text"
          id="new-value"
          value={newValue}
          onChange={(e) => setNewValue(e.target.value)}
          placeholder="Enter new value"
        />

        {selectedField && newValue && (
          <button
            onClick={handleUpdateUser}
            disabled={loading}
          >
            {loading ? 'Updating...' : 'Confirm Update'}
          </button>
        )}
      </div>

      <div className="logout-section">
        <button className="red-button" onClick={handleLogout}>Logout</button>
      </div>

      {showLogoutModal && (
        <div className="logout-modal">
          <div className="modal-content">
            <h3>Are you sure you want to log out?</h3>
            <button className="red-button" onClick={confirmLogout}>Yes, Logout</button>
            <button className="red-button" onClick={cancelLogout}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageWithdraw;
